import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTcsmEpiProps, setPensionEnrollmentSettings } from '../../../../../global/ducks/epi-api';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';

export function usePensionEnrollmentSettings(pensionEnrollmentSettingsId: string) {
	const dispatch = useDispatch();
	const epiApiState = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);

	useEffect(() => {
		if (!epiApiState?.pensionEnrollmentSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, pensionEnrollmentSettingsId, { guid }, language, false, setPensionEnrollmentSettings));
		}
	}, []);

	return epiApiState?.pensionEnrollmentSettingsState?.contentLoaded;
}